import React, { Component } from 'react';
// import { Router, Route, Switch } from "react-router";
// import {courtspace} from '../images/courtspace.png'; 
// import { Grid, Row, Col } from 'react-flexbox-grid';
import './App.css';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import { BrowserRouter as Router } from "react-router-dom";
import queryString from 'query-string'
import {FirebaseConfig} from './ApiKeys'
import * as firebase from 'firebase'
import 'firebase/firestore'
// import 'firebase/<PACKAGE>'

// initialize firebase 
if(!firebase.apps.length) {firebase.initializeApp(FirebaseConfig)}
// Initialize Cloud Firestore through Firebase
const db = firebase.firestore();
// db.settings(settings)


class Stripe extends Component {
  constructor(props) {
    super(props)
    this.state = {
      values:null
    }
  }

  _getStripeAuthCode=()=>{
    
  }



  componentDidMount() {
  this._createOwnerClientId()
  } 


_createOwnerClientId = ()=>{
   // GET PARAMETERS PASSED FROM STRIPE BY QUERYING THE HTTP ADDRESS 
   const search = this.props.location.search
   // if (typeof(search) != "undefined") {
     const values = queryString.parse(search)
     // const parsed = queryString.parse(location.search);
     console.log('value',values);
     const uid = values.state
     const authCode = values.code
     // const scope = values.scope
   //   const user = firebase.auth().currentUser;
     if (uid != null) {
       // const uid = user.uid
       const docRefUser = db.collection("ownerUsers").doc(uid)
      //  return docRefUser.get()
      //  .then(()=>{
              return docRefUser.set({
               authCode:authCode,
               activedStripe:true,
               uid:uid, // trying 06.28.19 // this will overwrite the uid but I need to do it since, I am using this one in security  rules, the uid is passed from the app to stripe then tripe gives it back, I am comparing this uid with existing uid in the document. 
               // scope:scope
               
           }, { merge: true })

           //trying 07/10/19 to create a doc in a subcollection that then triggers an onCreate cloud function to do the http request and fetch the cliendId of connected account
           .then(()=>{
             const docRef2 = db.collection("ownerUsers").doc(uid).collection("fetchOwnerClientId").doc(uid)
               return docRef2.set({
               authCode:authCode,
               uid:uid, // trying 07.10.19 //  similar like above.. this subcollection was created when signup, actually when componentDidmount since I use the auth uid once inside the app.. then here, this will overwrite the uid but I need to do it since, I am using this one in security  rules, the uid is passed from the app to stripe then tripe gives it back, I am comparing this uid with existing uid in the document. 
             })
           }, { merge: true })
      //  })
       .catch((err)=>{console.log(err)})
  

       // 
       //trying to fetch users credentials from stripe 
     //   .then(()=>{
     //     return fetch('https://connect.stripe.com/oauth/token',{
     //       method:'POST',
     //       headers:{
     //         Accept: 'application/json',
     //         'Content-Type':'application/json'
     //       },
     //       body:
     //       JSON.stringify({
     //         // {
     //           client_secret: 'sk_test_8K6Q3lV5NpyYWRfnkP4iMgcS',
     //           code:authCode,
     //           grant_type:'authorization_code'
     //         // }
             
     //       })
     //     })
     //       .then((response)=> response.json())
     //         .then((responseJson)=>{
     //         // return responseJson
     //         //   console.log('responseJson',responseJson)
     //           const stripe_user_id = responseJson.stripe_user_id
     //           const docRefUser = db.collection("ownerUsers").doc(uid)
     //           return docRefUser.update({
     //             stripe_user_id:stripe_user_id
     //         })
     //      })
      
     // })
   // const query = new URLSearchParams(this.props.location.search);
   // const token = query.get('token')
   // console.log(token)//123

     // this.setState({
     //   values:values
     // })
     // console.log('valuesInState', this.state.values)
   }
   
}


  render() {
    return (
      // <div class=" container card grey darken-4">
<Router>
    <div class="container ">
      
      <div class="col s12 ">
       <div >
       <h1> </h1>
       </div>
     </div>
     <div class="col s12 ">
       <div class="card grey darken-4">
         <div class="card-content white-text center-align">
           <h3  >courtspace</h3>
           <p class="center-align">Thanks for activating your account :)</p>
         </div>
         <div class="card-action">
           {/* <a href="#">This is a link</a>
           <a href="#">This is a link</a> */}
         </div>
       </div>
     </div>
     
   </div>
</Router>
        
   
     
      // </div>  
    )
  }
}

export default Stripe;


